import React from 'react';
import { micahPortraitAbout } from '../data/products';
import SEO from '../components/seo/SEO';
import './EventsPage.css';

const EventsPage: React.FC = () => {
  return (
    <div className="events-page">
      <SEO
        title="Events"
        description="Upcoming events, pop-ups, and exhibitions by Micah Lynise. Stay tuned for announcements."
        path="/events"
      />

      <section className="events-hero">
        <div className="events-hero__layout container">
          <div className="events-hero__copy">
            <h1 className="events-hero__title">Events</h1>
            <p className="events-hero__body">
              Exciting things are on the way. I'll be announcing upcoming pop-ups,
              exhibitions, and live events soon — stay tuned.
            </p>
          </div>

          <div className="events-hero__image-col">
            <img
              src={micahPortraitAbout}
              alt="Micah Lynise"
              className="events-hero__image"
              width={560}
              height={747}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventsPage;
